import service from "./service"

const acceptCompanyInvitation = async (data) => {
    return service(data)
}

export default acceptCompanyInvitation
